import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaCheckbox from './VaCheckbox.vue'

export const VaCheckbox = withConfigTransport(_VaCheckbox)
